import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
const { string } = proptypes;

export const VendorCollectionTitle = ({ name, brandName, className }) => {
  const brandText = brandName.includes('/staticImages/') ? '' : brandName;
  return (
    <Row className={`vendor-collection__title ${className}`} data-testid="vendor-collection-title">
      <Col flatten className="vendor-collection__title--main">
        <h1 className="vendor-collection__collection-name--medium">
          {name}
        </h1>
        <h2>
          <span>
            <a
              className="product-header__brand-name disabled-link"
              href=" "// TODO: Add Brand link once back-end gets set up for it
            >
              {brandText}
            </a>
          </span>
        </h2>
      </Col>
    </Row>
  );
};

VendorCollectionTitle.displayName = 'VendorCollectionTitle';

VendorCollectionTitle.propTypes = {
  name: string.isRequired,
  brandName: string.isRequired,
  className: string
};

VendorCollectionTitle.defaultProps = {
  className: 'vendor-collection-title'
};